export const classesOnScroll = (function ($) {

    // generic variables
    let lastKnownScrollY = 0,
        currentScrollY = 0,
        scrollTolerance = 20, // 20px of tolerance to avoid header unpin when opening the menu
        // scrollPosition = 0,
        // body = document.body,
        // html = document.documentElement,
        ticking = false;

    // header
    let idOfHeader = "main-navbar",
        eleHeader = null,
        headerHeight = 0;

    // // scrollSpy
    // let spySection = null,
    //     spySections = {},
    //     spyIndex = 0;

    let classes = {
        pinned: "header-pin",
        unpinned: "header-unpin",
        addBackground: "header-background",
    };

    if (window.matchMedia('(max-width: 1023px)').matches) {
        headerHeight = 60;
    } else {
        headerHeight = 88;
    }

    // Throttle function utility
    function throttle(func, timeFrame) {
        let lastTime = 0;
        return function () {
            let now = new Date();
            if (now - lastTime >= timeFrame) {
                func();
                lastTime = now;
            }
        };
    }

    function onScroll() {
        currentScrollY = window.pageYOffset;
        // scrollPosition = html.scrollTop || body.scrollTop;
        requestTick();
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(update);
        }
        ticking = true;
    }

    function update() {
        // Manage header autohide
        if (eleHeader) {
            if (currentScrollY < (lastKnownScrollY-scrollTolerance)) {
                if (eleHeader.classList.contains(classes.unpinned)) {
                    eleHeader.classList.remove(classes.unpinned);
                    eleHeader.classList.add(classes.pinned);
                }
            } else if (currentScrollY > (lastKnownScrollY+scrollTolerance) && currentScrollY > headerHeight/2) {
                if (eleHeader.classList.contains(classes.pinned) || !eleHeader.classList.contains(classes.unpinned)) {
                    eleHeader.classList.remove(classes.pinned);
                    eleHeader.classList.add(classes.unpinned);
                }
            }
            if (currentScrollY > headerHeight) {
                if (!eleHeader.classList.contains(classes.addBackground)) {
                    eleHeader.classList.add(classes.addBackground);
                }
            } else {
                eleHeader.classList.remove(classes.addBackground);
            }
        }

        // // manage scrollSpy
        // if (spySection) {
        //     for (spyIndex in spySections) {
        //         if (spySections[spyIndex] <= (scrollPosition + 150)) {
        //             let menuActive = document.querySelector('.js-side-scroll-navigation-link.active');
        //             if (menuActive) {
        //                 menuActive.setAttribute('class', 'js-side-scroll-navigation-link');
        //                 document.querySelector('.side-nav__item > a[href*=' + spyIndex + ']').setAttribute('class', 'js-side-scroll-navigation-link active');
        //             }
        //         }
        //     }
        // }

        lastKnownScrollY = currentScrollY;
        ticking = false;
    }

    function init() {

        // get Header
        eleHeader = document.getElementById(idOfHeader);

        // // get scrollSpy
        // spySection = document.querySelectorAll(".js-progress-section");
        // Array.prototype.forEach.call(spySection, function(e) {
        //     spySections[e.id] = e.offsetTop;
        // });

        setTimeout(function() {
            // add background if page is refreshed not at the top
            if (eleHeader && window.pageYOffset > headerHeight/2) {
                if (!eleHeader.classList.contains(classes.addBackground)) {
                    eleHeader.classList.add(classes.addBackground);
                }
                // unpin header on automatic scroll (eg: hash navigation)
                if (
                    eleHeader.classList.contains(classes.pinned) ||
                    !eleHeader.classList.contains(classes.unpinned)
                ) {
                    eleHeader.classList.remove(classes.pinned);
                    eleHeader.classList.add(classes.unpinned);
                }
            }

            // start scroll event
            document.addEventListener("scroll", throttle(onScroll, 10), { passive: true });

        }, 1000);

        throttle();
        onScroll();
        requestTick();
        update();

    }

    return {
        init: init
    }

})(jQuery);
